(() => {
  const cache = new Map(), queue = [], warmed = new Set();
  let active = 0;
  const load = (src, priority = 'high') => {
    if (!src) return Promise.reject(new Error('Missing garment image'));
    if (cache.has(src)) {
      const entry = cache.get(src);
      cache.delete(src); cache.set(src, entry);
      if (priority === 'high') entry.image.fetchPriority = 'high';
      return entry.promise;
    }
    const image = new Image();
    image.crossOrigin = 'anonymous'; image.decoding = 'async'; image.fetchPriority = priority;
    const entry = { image, ready: false };
    entry.promise = new Promise((resolve, reject) => {
      image.onload = async () => {
        try { await image.decode(); } catch {}
        entry.ready = true;
        while (cache.size > 16) {
          const old = [...cache].find(([key, value]) => key !== src && value.ready);
          if (!old) break;
          cache.delete(old[0]);
        }
        resolve(image);
      };
      image.onerror = () => { cache.delete(src); warmed.delete(src); reject(new Error('Garment image unavailable')); };
    });
    cache.set(src, entry); image.src = src;
    return entry.promise;
  };
  const pump = () => {
    if (document.hidden) return;
    while (active < 2 && queue.length) {
      const src = queue.shift(); active++;
      load(src, 'low').catch(() => {}).finally(() => { active--; pump(); });
    }
  };
  const warm = sources => {
    const connection = navigator.connection;
    if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
    sources.filter(Boolean).forEach(src => { if (!warmed.has(src)) { warmed.add(src); queue.push(src); } });
    pump();
  };
  const near = (element, sources) => {
    if (!('IntersectionObserver' in window)) return () => {};
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { warm(sources); observer.disconnect(); }
    }, { rootMargin: '300px' });
    observer.observe(element);
    return () => observer.disconnect();
  };
  document.addEventListener('visibilitychange', pump);
  window.superGarmentImages = { load, warm, near };
})();
